import { z } from 'zod';
import { isoDateTimeSchema } from '../../common.js';
/**
 * REST contract for the Claude connector token's lifecycle
 * (`POST/GET/DELETE /api/mcp/connector-token`, WF-1.2, docs/MCP-CONNECTOR-PLAN.md D1) —
 * schema shape cloned from `calendarFeed/schema.ts`'s feed-token contract. The token itself
 * is only ever returned once, straight out of mint — `GET` (status) never echoes it back,
 * matching the session-token-hashing posture: a leaked status response reveals nothing
 * replayable.
 */
export const connectorTokenStatusResponseSchema = z.object({
    exists: z.boolean(),
    createdAt: isoDateTimeSchema.nullable(),
    lastUsedAt: isoDateTimeSchema.nullable(),
});
export const mintConnectorTokenResponseSchema = z.object({
    token: z.string().min(1),
});
/** Path segment Claude's cloud hits for the JSON-RPC endpoint itself:
 * `/api/mcp/c/<token>` (authless — D1: the URL *is* the secret, WS-22's exact posture). */
export const MCP_CONNECTOR_PATH_PREFIX = '/api/mcp/c/';
//# sourceMappingURL=schema.js.map